import SelectionForm from './selection/form_base';

export default class extends SelectionForm {
  static values = { single: Boolean };

  get _dimensions() {
    return ['shared'];
  }

  get _designItemIdentifier() {
    return 'share-design-item';
  }

  get _folderItemIdentifier() {
    return 'share-folder-item';
  }

  _hasSelection() {
    if (!this.singleValue) {
      return super._hasSelection();
    }

    return this.designItemTargets.some(
      (element) => element.querySelector('input[data-dimension="shared"]')?.checked
    );
  }
}
